import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AccessKeyService {
  private readonly JWT_TOKEN = 'JWT_TOKEN';

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
  }

  async signIn(chave: string, idQuestionario: number) {
    const body = {
      codigoAcesso: chave,
      idQuestionario
    };
    this.clearToken();
    const url = `${environment.apiUrl}/jurisdicionados/token`;

    const { data: { token } } = await this.http.post<any>(url, body).toPromise();
    this.saveToken(this.JWT_TOKEN, token);
  }

  async countMessages(idQuestionario: number) {
    const url = `${environment.apiUrl}/jurisdicionados/comunicacoes/has-comunicacao/${idQuestionario}`;
    return await this.http.get<any>(url).toPromise();
  }

  async signInComunications(chave: string, idQuestionario: number) {
    const body = {
      codigoAcesso: chave,
      idQuestionario
    };

    this.clearToken();
    const url = `${environment.apiUrl}/jurisdicionados/comunicacoes/token`;

    const { data: { token } } = await this.http.post<any>(url, body).toPromise();
    this.saveToken(this.JWT_TOKEN, token);
  }

  saveToken(token: string, value: string) {
    return sessionStorage.setItem(token, value);
  }

  getJwtToken() {
    return sessionStorage.getItem(this.JWT_TOKEN);
  }

  signOut(id: number) {
    this.clearToken();
    this.router.navigate(['/access-key'], {
      queryParams: {
        id
      }
    });
  }

  clearToken() {
    sessionStorage.removeItem(this.JWT_TOKEN);
    localStorage.removeItem(this.JWT_TOKEN);
  }

}
